var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhitecard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 52 52",
    style: {
      enableBackground: "new 0 0 52 52"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{fill:#232A2E;}\r\n\t.st2{fill:none;}\r\n\t.st3{fill:#222A2D;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M26.54,14.66c-1.97,0-3.57-1.47-3.81-3.36H1.5v32.77h49V11.3H30.33C30.08,13.19,28.48,14.66,26.54,14.66z  M11.64,20.06c1.75,0,3.18,1.43,3.18,3.19c0,1.77-1.43,3.19-3.18,3.19c-1.77,0-3.19-1.43-3.19-3.19 C8.45,21.49,9.88,20.06,11.64,20.06z M18.07,35.3H5.2v-1.62c0-2.82,2.28-5.1,5.1-5.1h2.67c2.82,0,5.1,2.28,5.1,5.1V35.3z  M46.8,35.78l-24.56,0.04c0,0,0,0,0,0c-0.28,0-0.5-0.22-0.5-0.5c0-0.28,0.22-0.5,0.5-0.5l24.56-0.04h0c0.28,0,0.5,0.22,0.5,0.5 C47.3,35.56,47.08,35.78,46.8,35.78z M46.8,31.97l-24.56,0.04c0,0,0,0,0,0c-0.28,0-0.5-0.22-0.5-0.5c0-0.28,0.22-0.5,0.5-0.5 l24.56-0.04h0c0.28,0,0.5,0.22,0.5,0.5C47.3,31.75,47.07,31.97,46.8,31.97z M46.79,28.16L22.23,28.2c0,0,0,0,0,0 c-0.28,0-0.5-0.22-0.5-0.5c0-0.28,0.22-0.5,0.5-0.5l24.56-0.04h0c0.28,0,0.5,0.22,0.5,0.5C47.29,27.94,47.07,28.16,46.79,28.16z  M46.79,24.35l-24.56,0.04c0,0,0,0,0,0c-0.28,0-0.5-0.22-0.5-0.5c0-0.28,0.22-0.5,0.5-0.5l24.56-0.04h0c0.28,0,0.5,0.22,0.5,0.5 C47.29,24.13,47.06,24.35,46.79,24.35z M46.78,19.55L46.78,19.55c0.28,0,0.5,0.22,0.5,0.5c0,0.28-0.22,0.5-0.5,0.5l-24.56,0.04 c0,0,0,0,0,0c-0.28,0-0.5-0.22-0.5-0.5c0-0.28,0.22-0.5,0.5-0.5L46.78,19.55z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1,45.07h50c0.28,0,0.5-0.22,0.5-0.5V10.8c0-0.28-0.22-0.5-0.5-0.5H30.33c0.02,0.17,0.05,0.33,0.05,0.5 c0,0.17-0.03,0.33-0.05,0.5H50.5v32.77h-49V11.3h21.23c-0.02-0.17-0.05-0.33-0.05-0.5c0-0.17,0.03-0.33,0.05-0.5H1 c-0.28,0-0.5,0.22-0.5,0.5v33.77C0.5,44.84,0.72,45.07,1,45.07z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M21.72,20.08c0,0.28,0.22,0.5,0.5,0.5c0,0,0,0,0,0l24.56-0.04c0.28,0,0.5-0.22,0.5-0.5 c0-0.28-0.22-0.5-0.5-0.5h0l-24.56,0.04C21.94,19.58,21.72,19.81,21.72,20.08z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M46.79,23.35L46.79,23.35l-24.56,0.04c-0.28,0-0.5,0.22-0.5,0.5c0,0.28,0.22,0.5,0.5,0.5c0,0,0,0,0,0 l24.56-0.04c0.28,0,0.5-0.22,0.5-0.5C47.29,23.58,47.06,23.35,46.79,23.35z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M46.79,27.16L46.79,27.16L22.23,27.2c-0.28,0-0.5,0.22-0.5,0.5c0,0.28,0.22,0.5,0.5,0.5c0,0,0,0,0,0 l24.56-0.04c0.28,0,0.5-0.22,0.5-0.5C47.29,27.39,47.07,27.16,46.79,27.16z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M46.8,30.97L46.8,30.97l-24.56,0.04c-0.28,0-0.5,0.22-0.5,0.5c0,0.28,0.22,0.5,0.5,0.5c0,0,0,0,0,0l24.56-0.04 c0.28,0,0.5-0.22,0.5-0.5C47.3,31.2,47.07,30.97,46.8,30.97z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M46.8,34.78L46.8,34.78l-24.56,0.04c-0.28,0-0.5,0.22-0.5,0.5c0,0.28,0.22,0.5,0.5,0.5c0,0,0,0,0,0l24.56-0.04 c0.28,0,0.5-0.22,0.5-0.5C47.3,35,47.08,34.78,46.8,34.78z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M12.97,28.58H10.3c-2.82,0-5.1,2.28-5.1,5.1v1.62h12.87v-1.62C18.07,30.86,15.79,28.58,12.97,28.58z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M11.64,26.45c1.75,0,3.18-1.43,3.18-3.19c0-1.77-1.43-3.19-3.18-3.19c-1.77,0-3.19,1.43-3.19,3.19 C8.45,25.02,9.88,26.45,11.64,26.45z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M26.54,6.93c-1.97,0-3.57,1.47-3.81,3.36h7.6C30.08,8.4,28.48,6.93,26.54,6.93z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M26.54,14.66c1.94,0,3.54-1.47,3.79-3.36h-7.6C22.97,13.19,24.57,14.66,26.54,14.66z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M22.73,11.3h7.6c0.02-0.17,0.05-0.33,0.05-0.5c0-0.17-0.03-0.33-0.05-0.5h-7.6c-0.02,0.17-0.05,0.33-0.05,0.5 C22.68,10.97,22.7,11.13,22.73,11.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhitecard);
export default __webpack_public_path__ + "static/media/whitecard.45dec45abaf8e2ec25efec64a4a3fae2.svg";
export { ForwardRef as ReactComponent };